export default __webpack_public_path__ + "static/media/callraise_0009_thumb.66b5deb4.jpg";